import { useLoginVerifyQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/AccessRpc.hooks';
import { getPortalAccountId, getPortalInstanceId } from '../utils/metadata';
import { usePortalsPlatformObjectId } from '../context/PortalsPlatformObjectIdContext';
export function useLoginVerify(options) {
  var _options$objectId;
  const accountId = getPortalAccountId();
  const portalInstanceId = getPortalInstanceId();
  const contextObjectId = usePortalsPlatformObjectId();
  const objectId = (_options$objectId = options === null || options === void 0 ? void 0 : options.objectId) !== null && _options$objectId !== void 0 ? _options$objectId : contextObjectId;
  return useLoginVerifyQuery({
    variables: {
      accountId,
      portalInstanceId,
      objectId,
      tolerateInstanceAccessDenied: true
    }
  });
}